/**
 * Activity Types Component
 * Displays activity type breakdown with counts, hours, and percentages
 */

import { Box, Paper, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { CertificateIcon } from 'src/v3/core/icons'
import { ActivityType } from '../../types'

interface ActivityTypesProps {
  data: ActivityType[]
}

export default function ActivityTypes({ data }: ActivityTypesProps) {
  let theme = useTheme()

  let getActivityColor = (activityType: string) => {
    switch (activityType.toLowerCase()) {
      case 'recorded courses':
        return theme.palette.analyticsColors.recordedCourses
      case 'live classes':
        return theme.palette.analyticsColors.liveClasses
      case 'external certificates':
        return theme.palette.analyticsColors.externalCerts
      case 'events':
        return theme.palette.analyticsColors.events
      default:
        return 'primary.main'
    }
  }

  return (
    <Paper sx={{ p: 3 }}>
      <Typography
        variant="h6"
        sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}
      >
        <CertificateIcon />
        Activity Types
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {data.map((activity, index) => {
          let color = getActivityColor(activity.activityType)
          return (
            <Box key={index}>
              <Box
                sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}
              >
                <Typography variant="body2">{activity.activityType}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {activity.count} ({Math.round(activity.percentage)}%)
                </Typography>
              </Box>
              <Box
                sx={{
                  width: '100%',
                  height: 8,
                  bgcolor: 'background.paperDark',
                  borderRadius: 1,
                  overflow: 'hidden',
                }}
              >
                <Box
                  sx={{
                    width: `${activity.percentage}%`,
                    height: '100%',
                    bgcolor: color,
                    transition: 'width 0.3s ease',
                  }}
                />
              </Box>
            </Box>
          )
        })}
      </Box>
    </Paper>
  )
}
